import 'styles/base.scss'
import {Urls} from '../constants/index.js'
import { waitForElem } from "../utils/waitForElem.js";
import { waitForElemWithAttr } from '../utils/waitForElemWithAttr.js';
import { messagesNotification } from '../utils/messagesNotification.js';

(function () {
    /* global $ */
    "use strict";

	const authSettings = $.sc.authSettings;

	function updateCopyrightYear() {
        const currentYear = new Date().getFullYear();
        const copyrightElement = document.getElementById('copyrightYear');

        if (copyrightElement) {
            // Use the current year or fallback to 2025 if something goes wrong
            const displayYear = isNaN(currentYear) ? 2025 : currentYear;
			copyrightElement.innerHTML = `<p>&copy; Bath &amp; North East Somerset ${displayYear}. <a target="_blank" data-router-slot="disabled" href="https://www.pplinnovate.co.uk/" title="Powered by PPL Innovate" type="external">Powered by PPL Innovate</a></p>`;
		}
    }


	function addHeaderLinks() {

		$('.pcg-navigation__list').append(
			`
			${
				$.sc.authSettings.login !== null ? 
					($.sc.authSettings.isSag === true || authSettings.isOrgAdmin === true ? 
						`
							<li class="pcg-navigation__item">
								<a href="/s4s/CustomPage/Index/151" class="pcg-navigation__link pcg-contrast__link">Dashboard</a>
							</li>
							<li class="pcg-navigation__item">
								<a href="/s4s/Administration" class="pcg-navigation__link pcg-contrast__link">Administration</a>
							</li>
						` 
							: 
						`
							<li class="pcg-navigation__item">
								<a href="/s4s/CustomPage/Index/${Urls.homePage}" class="pcg-navigation__link pcg-contrast__link">Dashboard</a>
							</li>
							<li class="pcg-navigation__item">
								<a href="/s4s/CustomPage/Index/${Urls.searchProfilePage}" class="pcg-navigation__link pcg-contrast__link">${$.sc.authSettings.isEmployee === true ? `Find a vacancy` : `Find a Provider`}</a>
							</li>
							<li class="pcg-navigation__item" id="messages-header-notification">
								<a href="/s4s/CustomPage/Index/${Urls.homePage}#/messages" class="pcg-navigation__link pcg-contrast__link">Messages</a>
							</li>
						`
					) 
				:
				`
					<li class="pcg-navigation__item">
						<a href="/s4s/CustomPage/Index/${Urls.aboutPage}" class="pcg-navigation__link pcg-contrast__link">About this website</a>
					</li>
					<li class="pcg-navigation__item">
						<a href="/s4s/CustomPage/Index/${Urls.infoForEmployersPage}" class="pcg-navigation__link pcg-contrast__link">Information for employers</a>
					</li>
					<li class="pcg-navigation__item">
						<a href="/s4s/CustomPage/Index/${Urls.infoForProvidersPage}" class="pcg-navigation__link pcg-contrast__link">Information for providers</a>
					</li>
				`
			}
			`
		);

	}

	function adjustLogInOutBtns() {
		if ( $.sc.authSettings.login !== null) {

			$('.pcg-header__user').hide();

			const userName = $.sc.authSettings.name; 

			waitForElemWithAttr('.js-login-link', '/s4s/CustomPage/Index/' + Urls.searchProfilePage).then(element => {
				const elem = $('.pcg-user');
				$(elem).html(
					`
						<a href="/s4s/MyProfile/MyProfileTab" class="pcg-user__link pcg-contrast__btn">Hello ${userName}</a>
						<a href="/s4s/auth/logout" class="pcg-user__link pcg-contrast__btn js-login-link">Log out</a>
					`
				)
			  });

			// This is for the situation when jQuery is not loaded
			waitForElem(`.js-login-link`).then(() => {
			const container = document.querySelector('.pcg-user');
			$(container).html(
				`
					<a href="/s4s/MyProfile/MyProfileTab" class="pcg-user__link pcg-contrast__btn">Hello ${userName}</a>
					<a href="/s4s/auth/logout" class="pcg-user__link pcg-contrast__btn js-login-link">Log out</a>
				`
			)
			})

			$('.pcg-header__user').show();

			  
		}
	}
        

	// Contrast
	function checkContrastStorage(){
		let contrast = localStorage.getItem('contrast');
		if ( contrast === 'contrast') {
			$('body').addClass('alt-contrast');
		} else {
			$('body').removeClass('alt-contrast');
		}
	}

	// Font-size
	function checkFontSizeStorage(){

		let fontSize = localStorage.getItem('font-size');

		if ( fontSize === '' || fontSize === 'xs' ) {
			$('html').css('font-size', '1rem');

		} else if (fontSize === 'sm') {
			$('html').css('font-size', '1.5rem');

		} else if (fontSize === 'md') {
			$('html').css('font-size', '2rem');
		}
	}

    var Attributes = {


        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();

			addHeaderLinks();
			adjustLogInOutBtns();
			// if ( $.sc.authSettings.login === 'testuse1592+5222@gmail.com' || $.sc.authSettings.login === 'testuse1592+5221@gmail.com' || $.sc.authSettings.login === 'acozma@peopleplaceslives.co.uk' ) {
			// 	messagesNotification('#messages-header-notification');
			// }
			
        },

        adjustDom: function () {

			waitForElem(`#copyrightYear`).then(() => {
				updateCopyrightYear();
			});

			// Create the log in buttons
			if ( authSettings.login === null) {
				$('.js-login-btn__container').html('<a href="/s4s/Auth/SignInOidc" class="pcg-user__link pcg-contrast__btn js-login-link">Log in</a><a href="/s4s/CustomPage/Index/' + Urls.page_registrationLandingPage + '" class="pcg-user__link pcg-user__link--register pcg-contrast__btn">Register</a>')
			
			} else {
				$('.js-login-btn__container').html('<a href="/s4s/MyProfile/MyProfileTab" class="pcg-user__link pcg-contrast__btn">Hello ' + authSettings.name + '</a><a href="/s4s/Auth/Logout" class="pcg-user__link pcg-contrast__btn js-login-link">Log out</a>')
			}
		

			// Show work as button
			if((authSettings.isSag === true || authSettings.isOrgAdmin === true) && authSettings.isWorkAsMode === false){

				waitForElem(`.pcg-accessibility-bar`).then(() => {
					$('.pcg-accessibility-bar').append(
						`
						<div class="pcg-accessibility-bar__item">
							<a class="pcg-accessibility-bar__link pcg-contrast__link workas-btn" href="/s4s/UserManagement/Users">Work as</a>
						</div>
						
						`
					);
				});
			};
		
			// Show end work as button
			if(authSettings.isWorkAsMode === true || (authSettings.isWorkAsMode === true && authSettings.isOriginalPrincipalSag === true)){
		
				waitForElem(`.pcg-accessibility-bar`).then(() => {
					$('.pcg-accessibility-bar').append(
					`
					<div class="pcg-accessibility-bar__item">
							<a class="pcg-accessibility-bar__link  pcg-contrast__link workas-btn" href="/s4s/WorkAs/EndWorkAs">Stop working as ${authSettings.name}</a>
					</div>
					`
					);
				});          
			};

			
			if( window.location.href.indexOf('/s4s/SignUp/PersonalDetails') > -1 ) {

				$('#PreferableContactTypeStr').closest('fieldset').hide();
			}

			if( window.location.href.indexOf('/s4s/PPLRegistrations/Registrations') > -1 ) {
				$('body').addClass('PPL-registration')
			}
	
			if( window.location.href.indexOf('/s4s/PPLRegistrations/Details') > -1 ) {
				$('body').addClass('PPL-registration-details')
			}

			if (window.location.href.toLowerCase().indexOf('/s4s/signup/registrationconfirmation') > -1) {
				$('body').addClass('PPL-registration-confirmation')
			}
	
			if( window.location.href.indexOf('/s4s/UserManagement') > -1 ) {
            
				waitForElem(`#tree`).then(() => {
					$("#tabs li:has(a[action='NotificationsTab'])").hide();
					$("#tabs li:has(a[action='SupportTeamTab'])").hide();
					$("#tabs li:has(a[action='CompletedFormsTab'])").hide();
					$('#FundedByLa').parent().parent().hide();
					$("#tree :last-child").hide();
				});
						
			}

			if( window.location.href.indexOf('/s4s/UserManagement/Users') > -1 ) {
				$('body').addClass('user-management')
			}

			if( window.location.href.indexOf('/PPLRegistrations/Registrations') > -1 ) {
            
				waitForElem(`#tree`).then(() => {
					$("#tree :last-child").hide();
				});
						
			}

			if( window.location.href.indexOf('FormsAdministration/FormResults') > -1 ) {
            
				$('#administrationExcerpt').html(
					`
						<h1>Submitted reviews</h1>
						<p>Here you can see all submitted reviews. You can see the Provider Profile name and name of user who submitted the review in the ‘Form result name’ column. Click on ‘Date last updated’ to filter by most recent. Click on the magnifying glass icon to view the review and the 'x' icon to delete the review.</p>
						<p><strong>Please note: once the review is deleted, it cannot be retrieved, so please take care when deleting.</strong></p>
					`
				);
				$('.left-columnAlt').hide();
				// waitForElem(`#tree`).then(() => {
				// 	$("#tree :last-child").hide();
				// });
						
			}

			

	
			if( window.location.href.indexOf('/s4s/EventAdministrationDetailsPublic/CreateDirectory') > -1 ) {
				$('body').addClass('create-directory')
	
				setTimeout(function(){
					$('label').each(function () {
	
						if ($(this).text() === 'Template name:') {
							$(this).parent().hide();
						}
	
						if ($(this).text() === 'Category:') {
							$(this).parent().parent().parent().parent().parent().parent().hide();
						}
	
					});
	
					$('label[for=Name]').html('Listing name:<span class="required-asterisk">*</span>');
					$('label[for=Name]').parent().parent().parent().prepend(`<li class="listing-guidance"><p>All information entered in the boxes below will be publicly viewable. If a field is not applicable please leave it blank. Please ensure the appropriate attributes are selected at the end of the form as these fields are used in the filter application.</p></li>`)
	
					$('legend').each(function () {
	
						if ($(this).text() === 'Special Offer details:') {
							$(this).parent().css('display', 'flex')
							$(this).css('line-height', '2rem')
						}
	
						if ($(this).text() === 'Longitude:') {
							$(this).parent().parent().parent().parent().parent().parent().parent().hide();
						}
	
						if ($(this).text() === 'Directory image (list):') {
							$(this).text('Upload image 1')
						}
	
						if ($(this).text() === 'Directory image (details):') {
							$(this).text('Upload image 2')
						}
	
						if ($(this).text() === 'Geolocation') {
							$(this).parent().css('display','flex')
							$(this).parent().css('flex-direction','column')
							$(this).parent().css('row-gap','2rem')
						}
	
					})
	
					$('h2.lhs strong').each(function () {
	
						if ($(this).text() === 'Attributes') {
							$(this).text('Categories')
						}
	
					});
	
					$('h2').each(function () {
	
						if ($(this).text() === 'User') {
							$(this).css('font-size', '1rem')
							$(this).text('Select the category options below that are relevant to your listing.')
						}
	
					});
	
					$('.repeating-schedule__label').parent().parent().parent().hide();
					$('.file-upload__label').text('Upload documents:')
					$('.documents__tree').hide()
	
				}, 1000);
				
			}
	
			if( window.location.href.indexOf('/s4s/EventsAdministration/Events') > -1 ) {
				$('body').addClass('PPL-events');

				waitForElem(`.amendArrow`).then(() => {
					$('.amendArrow').closest('.col').addClass('attribute-box');
					$('.attribute-box').parent().parent().addClass('attribute-box__container');

					$('.js-image-upload-container').closest('.blocks').addClass('directory-settings__container');
					$('#IsPublished').parent().addClass('isPublished__container');

					// $('.attribute-box__container > h2').text(`Select relevant options from the list below to tag your listing and help users find your service. Use the arrow icons to expand the options`);

					$('.isPublished__container label').text('Tick to publish')
					
				});

				$('.left-columnAlt').hide();

				// Hide Local authority instances
				$('.visible-overflow .section .col:first-child').hide();
				$('table.grid col:eq(3)').hide();
				$('table.grid th:eq(3)').hide();
				$('table.grid tr td:nth-child(4)').hide();
			}
	
			if( window.location.href.indexOf('/s4s/EventAdministrationDetails') > -1 
			|| window.location.href.indexOf('/s4s/EventWizard/AdditionalInformation') > -1 ) {
				$('body').addClass('PPL-events-details');

				waitForElem(`.amendArrow`).then(() => {
					$('.amendArrow').closest('.col').addClass('attribute-box');
					$('.attribute-box').parent().parent().addClass('attribute-box__container');

					$('.js-image-upload-container').closest('.blocks').addClass('directory-settings__container');
					$('#IsPublished').parent().addClass('isPublished__container');
					
					$('strong').each(function () {
						if ($(this).text() === 'Attributes') {
	
							$(this).parent().next().next().children().eq(0).replaceWith(`<p>Select relevant options from the list below to tag your listing and help users find your service. Use the arrow icons to expand the options</p>`)

						}
					});
	

					$('.isPublished__container label').text('Tick to publish')
				});

				waitForElem(`sc-event-documents`).then(() => {
					$('sc-event-documents').parent().prepend(
						`
							<p><strong>Please upload:</strong></p>
							<ol class="document-helper">
								<li>At least x2 Provider Case Studies where you have delivered the services in market for UK companies.</li>
								<li>A copy of any Insurance Policies that are in place and being maintained in line with the Provider Terms & Conditions.</li>
								<li>A copy of annual audited accounts for the preceding x2 years showing a positive balance sheet. If you are a sole trader or an enterprise, a statement on the company letterhead signed by one of the directors confirming you have had a positive balance sheet for the past x2 years.</li>
								<li>For providers in the MEaP region we also require you to upload a copy of certificate of Incorporation and/or Business Licence.</li>
							</ol>

							<div class="document-helper">
								<p>Any documents uploaded here will only be accessible by Department for Business and Trade Administrators and will be used solely to determine your listing’s suitability on the platform. They cannot be viewed by publicly or by other users.</p>
							</div>
						`
					)
				});

				let currentDirectoryText = $('#administrationExcerpt').find('label').text();
				currentDirectoryText = currentDirectoryText.replace('directory', 'listing')
				$('#administrationExcerpt').find('label').text(currentDirectoryText);

				$('#categoryNameText').closest('.account').hide();
				$('.repeating-schedule').closest('.ValidateAltNorm').hide();

				$('label[for="Name"]').html(`Listing name:<span class="required-asterisk">*</span>`);
				$('label[for=Name]').parent().parent().parent().prepend(`<li class="listing-guidance"><p>All information entered in the boxes below will be publicly viewable. If a field is not applicable please leave it blank. Please ensure the appropriate attributes are selected at the end of the form as these fields are used in the filter application.</p></li>`)


				$('label').each(function(){

					var label = $(this);
					var labelText = label.text();

					// Replace 'Local authority' with 'System'
					var updatedText = labelText.replace('Local authority', 'System');
					label.text(updatedText);
				})

				$('legend').each(function(){

					var label = $(this);
					var labelText = label.text();

					if ( labelText === 'LinkedIn:' || labelText === 'Twitter:' || labelText === 'Facebook:' ) {
						$(this).append(`<small>Please paste the link</small>`);
					}

					if ( labelText === 'Special Offer Name:' || labelText === 'Special Offer Discount:' || labelText === 'Special Offer Redemption Instructions:' ) {
						$(this).append(`<small>Please leave this field blank if you do not offer a special code</small>`);
					}
				})

			}


			

			// AUTH Login / Sign Up //
			if (window.location.href.indexOf('/s4s/auth?') > -1 || window.location.href.indexOf('/s4s/Auth?') > -1) {
				
				$('body').addClass('auth-page');

				function checkContrastSignIn(){
					if ( localStorage.getItem('contrast') === 'contrast') {
						$('#loginButtonId').attr('style','color: #00e1e8 !important;	background-color: #3a3a3a !important; border: 2px solid #00e1e8 !important;')
						$('#signUpPromo a').attr('style','color: #00e1e8 !important;	background-color: #3a3a3a !important; border: 2px solid #00e1e8 !important;')
					} else {
						$('#loginButtonId').removeAttr('style');
						$('#signUpPromo a').removeAttr('style');
					}
				}


				$('.js-accessibility-widget__contrast').click(function(){
					waitForElem(`#LoginBox`).then(() => {
						checkContrastSignIn();
					});
				})


				waitForElem(`#LoginBox`).then(() => {
					$('.loginPage').prepend('<div class="title-container"><h1>Login Details</h1></div>')
					$('#LoginBox').addClass('pcg-contrast__bg-main');
					$('#signUpPromo p').addClass('pcg-contrast__color-main')	
					checkContrastSignIn();
				});
			}

			// Direct Provider Registration
			if(window.location.href.indexOf(`/s4s/CustomPage/Index/${Urls.directProviderReg}?programId=${Urls.programId}`) > -1){
				$('body').addClass('directProviderRegistration');			
			} 

			// Direct Employer Registration
			if(window.location.href.indexOf(`/s4s/CustomPage/Index/${Urls.directEmployerReg}?programId=${Urls.programId}`) > -1){

				function checkCaptchaVisibility() {
					const captchaElement = document.querySelector('.js-ppl-registration-captcha');

					if (captchaElement) {
						const intervalId = setInterval(() => {
							const style = window.getComputedStyle(captchaElement);
							if (style.display === 'none') {
								console.log('Captcha is hidden');
							} else {
								console.log('Captcha is visible');
								if ($('.js-rechaptcha-warning').length === 0) {
									$('.js-ppl-registration-captcha').parent().prepend(`<div class="js-rechaptcha-warning rechaptcha-warning"> 
									<p>Please click on the checkbox below to <strong>complete the registration</strong> form.</p>
									<p>Failing to do so will result in not getting approved. <strong>This step is required to complete your registration successfully</strong>.</p>
									</div>`)
								}
									
							}
						}, 1000);
					} else {
						console.log('Captcha element not found');
					}
				}

				checkCaptchaVisibility();

			} 


			// Pre-registration
			if(window.location.href.indexOf('/s4s/UserManagement/ToPreRegistration') > -1){
				$('body').addClass('preRegistration');			
			} 

			if( window.location.href.indexOf('EventAdministrationDetailsPublic/Index/') > -1 ) {
				$('body').addClass('form-page');

				waitForElem(`.js-image-upload-container`).then(() => {
					$('legend').each(function () {
						if ($(this).text() === 'Directory image (list):') {
							$(this).text('Company logo (list):')
						}
	
						if ($(this).text() === 'Directory image (details):') {
							$(this).text('Company logo (details):')
						}

						if ($(this).text() === 'Company Video:') {
							$(this).parent().addClass('company-video-guidance')
						}
					})

					$("label[for='Name']").text('Organisation name:*')
					// $("label[for='OrganisationName']").parent().parent().hide()
					$("label[for='OrganisationName']").parent().hide();
					$("label[for='Phone']").parent().hide()
					$("label[for='Email']").parent().hide()
					$("label[for='IsPublished']").parent().hide();
					$("label[for='PublishDate']").parent().parent().hide();

					if ($.sc.authSettings.isSag === false || $.sc.authSettings.isOrgAdmin === false) {
						$('legend').each(function () {
							if ($(this).text() === 'The Provider Account Manager') {
								$(this).parent().parent().hide()
							}
						})
					} else {
						$('legend').each(function () {
							if ($(this).text() === 'The Provider Account Manager') {
								$(this).css('border','2px solid red')

								$(this).parent().parent().append(`
									<div class="document-helper">
										<p><strong>Administrators please ensure that you have indicated which region manages this provider. The account manager should be contacted with all queries related to this provider.</strong></p>
									</div>
								`)
							}
						})
					}
				});
			}


			// Directory Management
			if( window.location.href.indexOf('/s4s/EventAdministrationDetails/') > -1 ) {
				$("#tabs a").each(function() {
					if ($(this).text() === 'Event details') {
						$(this).text('Listing details');
					}

					if ($(this).text() === 'Subscription' || $(this).text() === 'Admin data') {
						$(this).parent().hide();
					}
				});
			}

			if( window.location.href.indexOf('/s4s/EventAdministrationDetails/EventDetails') > -1 ) {

				waitForElem(`#AllowedSPIds`).then(() => {
					$("label[for='AllowedSPIds']").text('Provider owner:')
					$("label[for='AllowedLAIds']").parent().hide();
					$("label[for='EventOwnerIds']").text('Listing managers:')

					$('legend').each(function () {

						if ($(this).text() === 'Company Video:') {
							$(this).parent().addClass('company-video-guidance')
						}

						if ( 
							$(this).text() === 'Spare 5:' ||
							$(this).text() === 'Spare 6:' ||
							$(this).text() === 'Spare 7:' ||
							$(this).text() === 'Spare 8:'
						) {
							$(this).closest('.ValidateDropdown ').hide();
						}
					})

					if ($.sc.authSettings.isSag === false) {
						$('legend').each(function () {
							if ($(this).text() === 'The Provider Account Manager') {
								$(this).parent().parent().hide()
							}
						})
					} else {
						$('legend').each(function () {
							if ($(this).text() === 'The Provider Account Manager') {
								$(this).css('border','2px solid red')
								$(this).parent().parent().append(`
									<div class="document-helper">
										<p><strong>Administrators please ensure that you have indicated which region manages this provider. The account manager should be contacted with all queries related to this provider.</strong></p>
									</div>
								`)
							}
						})
					}
				});

				waitForElem(`.isPublished__container`).then(() => {
					$('.isPublished__container').prepend('<p>Note to admin: Please confirm you have completed checks on the providers insurance, case studies and financial information</p>')
				})
			}

			// MyProfileTab
			if( window.location.href.indexOf('/s4s/MyProfile/MyProfileTab') > -1 ) {

				function checkContrastMyProfile(){
					if ( localStorage.getItem('contrast') === 'contrast') {
						$('#myAccountExcerpt h1').attr('style','color: #ff0 !important;')
						$('#myAccountExcerpt p').addClass('pcg-contrast__color-main')
					} else {
						$('#myAccountExcerpt h1').removeAttr('style');
					}
				}

				$('.js-accessibility-widget__contrast').click(function(){
					waitForElem(`#PreferableContactTypeStr_Email`).then(() => {
						checkContrastMyProfile()
					});
				})


				waitForElem(`#PreferableContactTypeStr_Email`).then(() => {
					$('#myAccountExcerpt').append('<p>To change your password, click on ‘Edit private data’ button.</p>')
					$('.noBorders').removeClass('col');
					$('#PreferableContactTypeStr_Email').parent().parent().parent().parent().parent().hide();
					$('#DateOfBirth_day').parent().parent().parent().hide();

					$('a[action="AdditionalInformationTab"]').parent().remove();
					$('a[action="AskTheExpertDetailsTab"]').parent().remove();

					$('span.initial-color').closest('#liquid-round').hide();

					if ( $.sc.authSettings.isEmployee === true) {
						$('#Fax').closest('.ValidateAltNorm').hide();
						$('#SocialSecurityNumber').closest('.ValidateAltNorm').hide();
						$('.js-mobile-phone-container').show();
					}

					$("label[for='Position']").text('Company:')
					$('.phone-number__country-code').hide();

					checkContrastMyProfile()
				});

				waitForElem(`.js-phone-editor`).then(() => {
					$("label[for='UserPicUploadImage']").parent().hide();
					$(".js-phone-editor").hide();
				})
			
			}

			// User Details
			if( window.location.href.indexOf('/s4s/UserManagement/UserDetailsTab/') > -1 ) {
				waitForElem(`.js-save-action`).then(() => {
					$("label[for='Position']").text('Company:')
					$('#BirthDate_day').parent().parent().parent().hide();
					$("label[for='Fax']").parent().parent().hide();
					$("label[for='PreferableContactTypeStr']").parent().parent().hide();
					$("label[for='PayrollOrganisationIdString']").parent().parent().hide();

				})
			}

			
			// DocumentsTab
			if( window.location.href.indexOf('/s4s/MyProfile/DocumentsTab') > -1 ) {
				
				function checkContrastDocumentsTab(){
					if ( localStorage.getItem('contrast') === 'contrast') {
						$('#myAccountExcerpt h1').attr('style','color: #ff0 !important;')
						$('.entityForm p').addClass('pcg-contrast__color-main')
					} else {
						$('#myAccountExcerpt h1').removeAttr('style');
					}

				}

				$('.js-accessibility-widget__contrast').click(function(){
					waitForElem(`#PreferableContactTypeStr_Email`).then(() => {
						checkContrastDocumentsTab()
					});
				})

				waitForElem(`a[action="AdditionalInformationTab"]`).then(() => {
					$('a[action="AdditionalInformationTab"]').parent().remove();
					$('a[action="AskTheExpertDetailsTab"]').parent().remove();
					checkContrastDocumentsTab()
				});
			
			}


			if( window.location.href.indexOf('/s4s/signUp/PersonalDetails') > -1 ) {


				function checkContrastPersonalDetails(){
					if ( localStorage.getItem('contrast') === 'contrast') {
						$('.bottomRibbon a').attr('style','color: #00e1e8 !important;	background-color: #3a3a3a !important; border: 2px solid #00e1e8 !important;')
						$('.bold').attr('style','color: #00e1e8 !important;')
					} else {
						$('.bottomRibbon a').removeAttr('style');
						$('.bold').removeAttr('style');
					}

					$('.bold span a').addClass('pcg-contrast__link')
				}

				$('.js-accessibility-widget__contrast').click(function(){
					waitForElem(`#OrganisationIdString`).then(() => {
						checkContrastPersonalDetails()
					});
				})


				waitForElem(`#OrganisationIdString`).then(() => {
					$('#OrganisationIdString').parent().hide();
					$('#PreferableContactTypeStr_Email').closest('fieldset').hide();

					$("a:contains('Terms and Conditions')").attr('href', '/s4s/CustomPage/Index/' + Urls.page_termsConditions);
					$('#myLifeExcerpt').html(`<h1>User Registration</h1>`)
					$("label[for='Position']").text('Company:')
					checkContrastPersonalDetails()
				});

				if ('.validation-summary-errors') {
					waitForElem(`.validation-summary-errors`).then(() => {
						setTimeout(() => {
							$('.validation-summary-errors').attr('tabindex', '0').focus();
						}, 500);
					})
				}

				$('.js-next-step-button').on('click',function(){
					waitForElem(`.validation-summary-errors`).then(() => {
						setTimeout(() => {
							$('.validation-summary-errors').attr('tabindex', '0').focus();
						}, 500);
					})
				})
				
			}

			if( window.location.href.indexOf('/s4s/EventWizard/') > -1 ) {

				$('#myLifeExcerpt h1').text('Create Listing')
				
			}

			if( window.location.href.indexOf('/s4s/EventWizard/MainDetails') > -1 ) {

				waitForElem(`.js-next-step-button`).then(() => {
					$('#EventTemplateIdString').parent().parent().parent().append('<li class="ValidateAltSmall"><p>Click Additional Information to continue to your provider profile and complete your company details.</p></li>')
				});
				
			}


			if( window.location.href.indexOf('s4s/EventWizard/AdditionalInformation') > -1 ) {

				waitForElem(`.js-image-upload-container`).then(() => {
					$('#PublishDate').parent().parent().hide();
					$('#AllowedSPIds').parent().parent().hide();
					$('#AllowedLAIds').parent().parent().hide();
					$('#EventOwnerIds').parent().parent().hide();
					$("label[for='IsPublished']").parent().hide();
					$("label[for='IsApprovalRequested']").text('Tick to send for approval:')
					$("label[for='IsApprovalRequested']").parent().addClass('isPublished__container')
					$('legend').each(function () {
						if ($(this).text() === 'Directory image (list):') {
							$(this).text('Company logo (list):')
						}
	
						if ($(this).text() === 'Directory image (details):') {
							$(this).text('Company logo (details):')
						}

						if ($(this).text() === 'Company Video:') {
							$(this).parent().addClass('company-video-guidance')
						}

						if ( 
							$(this).text() === 'Spare 5:' ||
							$(this).text() === 'Spare 6:' ||
							$(this).text() === 'Spare 7:' ||
							$(this).text() === 'Spare 8:'
						) {
							$(this).closest('.ValidateDropdown ').hide();
						}
						
					})

					$("label[for='Name']").text('Organisation name:*')
					$("label[for='OrganisationName']").parent().hide();
					$("label[for='Phone']").parent().hide()
					$("label[for='Email']").parent().hide()

					if ($.sc.authSettings.isSag === false || $.sc.authSettings.isOrgAdmin === false) {
						$('legend').each(function () {
							if ($(this).text() === 'The Provider Account Manager') {
								$(this).parent().parent().hide()
							}
						})
					} else {
						$('legend').each(function () {
							if ($(this).text() === 'The Provider Account Manager') {
								$(this).css('border','2px solid red')
								$(this).parent().parent().append(`
									<div class="document-helper">
										<p><strong>Administrators please ensure that you have indicated which region manages this provider. The account manager should be contacted with all queries related to this provider.</strong></p>
									</div>
								`)
							}
						})
					}

				});
				
				
			}

			// Ratings and reviews
			// if ( window.location.href.indexOf('formId=1') > -1) {

			// 	waitForElem(`.star-ratings`).then(() => {

			// 		$('.star-ratings').each(function(){

			// 			$(this).find('.form-radio__option').each(function(i){
			// 				i = i +1;
			// 				$(this).addClass('star-' + i);

			// 			});

			// 		});

			// 		$('.form-navigation-btns__btn_save').hide();
			// 		$('.form-navigation-btns__btn_finish').text('Submit review')
			// 	});


			// 	$('body').on('click', '.star-ratings .form-radio__option', function(){

			// 		$(this).parent().find('.form-radio__option').removeClass('selected');
			// 		$(this).addClass('selected');
			// 		$(this).prevAll().addClass('selected');
	
			// 	});
				
			// }

			if (typeof hiqPdfInfo !== "undefined") {
				//put script that hide all unnecessary fields here
				$('.letter-hide').remove();
				$('html').addClass('pdf-view');
		
				$('footer.pcg-footer').hide();
				$('.pcg-header__accessibility-bar').hide();
				$('.pcg-header__nav-col').hide();
				$('.pcg-header__search-bar').hide();
		
			}


			if( window.location.href.indexOf('/s4s/CmsContexts/ContentUpload') > -1 ) {
				$('body').addClass('all-buttons')
			}



			// Listing Request Removal Form
			if (window.location.href.indexOf('/s4s/FormDetails/FillForm?formId=2') > -1) {

				$('#app').addClass('listingRemoval');
				waitForElem(`.form-navigation-btns__btn_finish`).then(() => {
					$('.form-navigation-btns__btn_finish').addClass('pcg-contrast__btn')
				});
		
			   
				$('body').on('click', '.form-navigation-btns__btn_finish ', function () {
					$('.form-app').addClass('listingResult');

					$('.form-header__title').addClass('form-header__title_result');
				
					var closeButton = $('.form-header__action-buttons');

					setTimeout(() => {
						$( ".form-app" ).append(closeButton);
					  }, "1000");

					waitForElem(`.form-header__action-buttons button`).then(() => {
						$('.form-header__action-buttons button').addClass('pcg-contrast__btn')
					});
					
				})

				$('body').on('click', '.form-header__action-buttons', function () {
					window.location.href ="/s4s/CustomPage/Index/2"
				})

			}


			// Listing Request Removal Form - Administration - Form's Results
			if (window.location.href.indexOf('/s4s/FormResultsDetails/Entry/') > -1) {

				waitForElem(`.form-header__title`).then(() => {
					if ($('.form-header__title').text() === 'Listing removal form') {
						$('#app').addClass('listingRemoval');
						waitForElem(`.form-navigation-btns__btn_finish`).then(() => {
							$('.form-navigation-btns__btn_finish').addClass('pcg-contrast__btn')
						});
				
						$('.form-app').addClass('listingResultViewForm');
					
						$('.form-header__title').addClass('form-header__title_result');
				
	
						waitForElem(`.form-header__action-buttons button`).then(() => {
							$('.form-header__action-buttons button').addClass('pcg-contrast__btn')
						});		
	
						$('body').on('click', '.form-header__action-buttons', function () {
							window.location.href ="/s4s/FormsAdministration/FormResults"
						})
					}
				});

			}

			if (window.location.href.toLowerCase().indexOf('/s4s/auth') > -1) {
				waitForElem(`#signUpPromo a`).then(() => {
					$('#signUpPromo a').attr('href','/s4s/CustomPage/Index/338');
				}); 
			}


			// Contrast
			checkContrastStorage();

			// Font size
			checkFontSizeStorage()

			// Update document title
			let pagetitle = document.title
			if ( pagetitle === 'Create event') {
				pagetitle = 'Create listing';
			}
			document.title = pagetitle + "  | BSW"

        },

        bindUIActions: function () {


			$('.js-accessibility-widget__contrast').click(function(){
				if ( $(this).hasClass('contrast')) {
					let contrastMode = 'contrast';
					localStorage.setItem('contrast', contrastMode);
					$('body').addClass('alt-contrast');
				} else {
					$('body').removeClass('alt-contrast');
					localStorage.setItem('contrast', '');
				}
			});
			
			// Textsize
			$('.js-accessibility-widget__font-size').click(function(){
		
				if ( $(this).hasClass('xs')) {
					localStorage.setItem('font-size', 'xs');
					$('html').css('font-size', '1rem');
		
				} else if ($(this).hasClass('sm')) {
					localStorage.setItem('font-size', 'sm');
					$('html').css('font-size', '1.5rem');
		
				} else {
					localStorage.setItem('font-size', 'md');
					$('html').css('font-size', '2rem');
				}
			});

        },

        unload: function () {},
    };

    Attributes.init();
})();